module.exports = __webpack_public_path__ + "img/Group 827.bff0d429.svg";